import React from 'react';
import PropTypes from 'prop-types';

const CompanyStatus = ({ t = () => {}, isActive, userRoleName, isDemo }) => {
  const blockStyle = {
    minHeight: '60px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  };

  return (
    <div className="card-text d-flex text-center justify-content-center">
      <div className="px-4 border-end" style={{ ...blockStyle, borderRight: '1px solid #ccc' }}>
        <small className="text-muted d-block">{t('common.status')}</small>
        <strong>
          {t(isActive ? 'common.active' : 'common.deactivated', { context: 'female' })}
        </strong>
      </div>
      <div className="px-4 border-end" style={{ ...blockStyle, borderRight: '1px solid #ccc' }}>
        <small className="text-muted d-block">{t('companies.permissions')}</small>
        <strong>{userRoleName}</strong>
      </div>
      <div className="px-4" style={blockStyle}>
        <small className="text-muted d-block">{t('companies.typeService')}</small>
        <strong style={{ whiteSpace: 'nowrap' }}>{isDemo ? 'Demo' : 'Plan Contratado'}</strong>
      </div>
    </div>
  );
};

CompanyStatus.propTypes = {
  t: PropTypes.func.isRequired,
  isActive: PropTypes.bool.isRequired,
  userRoleName: PropTypes.string.isRequired,
};

export default CompanyStatus;



// WEBPACK FOOTER //
// src/modules/secured/modules/companies/components/CompanyStatus.js